import { RegionData } from '@/editor/data/region/Region';
import { TextInfo, ITextInfoConstructor } from './textInfo';

export class RegionTextInfo extends TextInfo<RegionData> {
  constructor(params: ITextInfoConstructor<RegionData>) {
    super(params);
    this._element.setAttribute('data-type', 'region');
  }
}
